import CommonStyleEditor from "./CommonStyleEditor";

export default function ButtonCellProperties({ cell, onChange }) {
    return (
        <div className="property-section">
            <div className="property-section-title">Button</div>
            <div className="property-row">
                <div className="property-label">Text</div>
                <input className="property-input property-input-small" type="text" value={cell.text} onChange={(e) => onChange(cell.cell_id, {text: e.target.value, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Taille de la police</div>
                <input className="property-input property-input-small" type="number" value={cell.styles_properties?.text_size || 16} onChange={(e) => onChange(cell.cell_id, {styles_properties: {...cell.styles_properties, text_size: parseInt(e.target.value)}, type: cell.type})}/>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    )
}